import React from 'react';
import PropTypes from 'prop-types';

import {Icon} from '@stubhub/bamboo';
import FormattedLink from '@stubhub/react-formatted-link';
import Urgency from '@stubhub/react-urgency';

import ArrowIcon from '../../components/icons/back_arrow';
import EventDate from '../../components/react-event-date-time-info';
import EventName from '../../components/react-event-name';

import './index.scss';

const EventInfoHeader = ({
  eventName,
  eventDate,
  eventDateLocal,
  venueName,
  venueWebURI,
  locality,
  state,
  goBack,
  eventTime,
  className = '',
  allPerformers,
  groupings,
  showImportantInfoModal,
  buyerMessages,
  handleImportantIconClick,
  totalTickets,
}) => {
  const whiteArrow = className === 'vip' ? '#F6F8F9' : '';

  return (
    <div className={`${className} RoyalEventInfo`}>
      {goBack && (
        <div className="RoyalEventInfo__closeButton" onClick={goBack}>
          <ArrowIcon color={whiteArrow} />
        </div>
      )}
      <div className="RoyalEventInfoWrapper">
        <div className="RoyalEventInfoWrapper-mainInfo">
          <div className="RoyalEventInfoWrapper__eventInfo">
            {eventName && (
              <EventName
                className="RoyalEventInfoWrapper__eventName"
                eventName={eventName}
                performers={allPerformers}
                groupings={groupings}
              />
            )}
            {eventDate && (
              <span>
                <EventDate className="RoyalEventInfoWrapper__eventDate" eventDate={eventDate} eventTime={eventTime} />
                &nbsp;
              </span>
            )}
            {venueName && (
              <span className="EventDateTimeInfo">
                at&nbsp;
                <FormattedLink href={venueWebURI}>{venueName}</FormattedLink>,&nbsp;
                {locality}, {state}
              </span>
            )}
          </div>
          {showImportantInfoModal && buyerMessages && buyerMessages.length > 0 && (
            <span className="important-icon" onClick={handleImportantIconClick}>
              <Icon size="sm" name="Info" data-testid="important-icon" />
            </span>
          )}
        </div>
        <Urgency
          eventDateLocal={eventDateLocal}
          totalTickets={totalTickets}
          className="RoyalEventInfoWrapper-urgency"
        />
      </div>
    </div>
  );
};

EventInfoHeader.propTypes = {
  eventName: PropTypes.string,
  eventDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  venueName: PropTypes.string,

  /** Venue URL */
  venueWebURI: PropTypes.string,

  /** City */
  locality: PropTypes.string,

  /** State */
  state: PropTypes.string,

  /** Function to call when back is clicked */
  goBack: PropTypes.func,
  eventTime: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /** The Class Name used to override the Styling for the component. */
  className: PropTypes.string,

  /** Array of performers */
  allPerformers: PropTypes.array,

  /** Array of groupings */
  groupings: PropTypes.array,

  /** If important messages can be shown */
  showImportantInfoModal: PropTypes.bool,

  /** Buyer messages */
  buyerMessages: PropTypes.array,

  /** Method to show important messages modal */
  handleImportantIconClick: PropTypes.func,

  /** EventDateLocal from event */
  eventDateLocal: PropTypes.any,

  /** TotalTickets from listingData */
  totalTickets: PropTypes.number,
};

export default EventInfoHeader;
